export var CONVERSATIONAL_INTENT = /* @__PURE__ */ ((CONVERSATIONAL_INTENT2) => {
  CONVERSATIONAL_INTENT2["AFFIRMATIVE"] = "affirmative";
  CONVERSATIONAL_INTENT2["NEGATIVE"] = "negative";
  CONVERSATIONAL_INTENT2["MAYBE"] = "maybe";
  CONVERSATIONAL_INTENT2["LATER"] = "later";
  CONVERSATIONAL_INTENT2["CANCEL"] = "cancel";
  CONVERSATIONAL_INTENT2["CHOICE"] = "choice";
  CONVERSATIONAL_INTENT2["UNKNOWN"] = "unknown";
  CONVERSATIONAL_INTENT2["CUSTOM"] = "custom";
  CONVERSATIONAL_INTENT2["HOW_MUCH"] = "how_much";
  CONVERSATIONAL_INTENT2["SHIPPING_METHODS"] = "shipping_methods";
  CONVERSATIONAL_INTENT2["DIFFERENT_QUESTION"] = "different_question";
  CONVERSATIONAL_INTENT2["PAY_NOW"] = "pay_now";
  CONVERSATIONAL_INTENT2["BUY"] = "buy";
  CONVERSATIONAL_INTENT2["CHANGE_ITEMS"] = "change_items";
  CONVERSATIONAL_INTENT2["CHANGE_PAYMENT"] = "change_payment";
  CONVERSATIONAL_INTENT2["CHANGE_SHIPPING"] = "change_shipping";
  CONVERSATIONAL_INTENT2["CHANGE_SOMETHING_ELSE"] = "change_something_else";
  CONVERSATIONAL_INTENT2["CHOOSE_SPECIFIC_ITEM"] = "choose_specific_item";
  CONVERSATIONAL_INTENT2["CHOOSE_DIFFERENT_ITEM"] = "choose_different_item";
  CONVERSATIONAL_INTENT2["RECOMMEND_PRODUCTS"] = "recommend_products";
  CONVERSATIONAL_INTENT2["SEARCH_FOR_PRODUCTS"] = "search_for_products";
  CONVERSATIONAL_INTENT2["ALREADY_ORDERED"] = "already_ordered";
  CONVERSATIONAL_INTENT2["SEND_DISCOUNT_CODE"] = "send_discount_code";
  CONVERSATIONAL_INTENT2["ORDER_STATUS"] = "order_status";
  CONVERSATIONAL_INTENT2["REFILL_CANCEL"] = "refill_cancel";
  CONVERSATIONAL_INTENT2["REFILL_SKIP"] = "refill_skip";
  CONVERSATIONAL_INTENT2["REFILL_WAIT"] = "refill_wait";
  CONVERSATIONAL_INTENT2["STOP"] = "stop";
  CONVERSATIONAL_INTENT2["OPT_OUT"] = "opt_out";
  CONVERSATIONAL_INTENT2["OPT_IN"] = "opt_in";
  CONVERSATIONAL_INTENT2["ANSWER_QUESTION"] = "answer_question";
  CONVERSATIONAL_INTENT2["GIVE_FEEDBACK"] = "give_feedback";
  return CONVERSATIONAL_INTENT2;
})(CONVERSATIONAL_INTENT || {});
